export default __webpack_public_path__ + "static/media/dislike.3d9a9e35.svg";